import { Events } from '../utils/Events'
import { Id } from '../utils/Id.js'
import { isElement } from '../utils/Is.js'

export class Block {
  constructor(el, page = document, id, type = 'Block', autoInit = true) {
    this.id = Id(id)
    this.components = []
    this.page = page

    if (!isElement(el)) {
      this.el = this.get(el, page)
    } else {
      this.el = el ?? null
    }

    if (autoInit) {
      this.init()
      this.addEvents()
    }
  }

  init() {}

  addEvents() {}

  destroy(transition, from) {
    this.components.forEach((component) => {
      if (component.activeObserver && component.unobserve) component.unobserve()
      if (component.destroy) component.destroy(transition, from)
    })

    this.components = []
  }

  get(selector, scope = this.el) {
    return scope.querySelector(selector)
  }

  getAll(selector, scope = this.el) {
    return Array.from(scope.querySelectorAll(selector))
  }

  on(event, callback, scope = this.el) {
    Events.on(event, scope, callback)
  }

  off(event, callback, scope = this.el) {
    Events.off(event, scope, callback)
  }

  add(selector, comp, scope = this.el, id = Id('Component'), multiple = false) {
    if (!multiple) {
      const nodeEl = this.get(selector, scope)
      if (nodeEl) {
        const newComp = new comp(nodeEl, this, id)
        this.components.push(newComp)
      }
    } else {
      const nodeEls = this.getAll(selector, scope)
      if (nodeEls.length) {
        nodeEls.forEach((el) => {
          if (el) {
            const newComp = new comp(el, this, id)
            this.components.push(newComp)
          }
        })
      }
    }
  }
}
